import styled from 'styled-components';

export const SoldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 20px;

	background: #fdeeee;
	border-radius: 8px;
	padding: 20px 24px;
	width: 100%;
	box-sizing: border-box;

	@media (max-width: 480px) {
		grid-gap: 10px;
	}
`;

export const SoldItem = styled.div`
	display: flex;
	justify-content: space-between;
	position: relative;
	width: 100%;
`;

export const SoldTitle = styled.div`
	${({ theme }) => theme.typography.textBoldL};
	color: ${({ theme }) => theme.orangeColor};
	align-self: center;
`;

export const SoldImage = styled.picture`
	position: relative;
	overflow: hidden;
	flex-shrink: 0;
	width: 138px;
	height: 112px;
	margin-bottom: -20px;
	margin-right: -24px;

	img {
		width: 100%;
	}

	@media (max-width: 800px) {
		width: 108px;
		height: 87px;
	}
`;

export const GradientDiv = styled.div`
	width: 100%;
	height: 100%;
	background: linear-gradient(rgb(253, 238, 238) 0%, rgba(253, 238, 238, 0) 0%, rgb(253, 238, 238) 100%);
	position: absolute;
	top: 75%;
	left: 14px;
`;
